import { gql } from '@apollo/client/core';

export const deletePart = gql`
  mutation deletePart($id: String) {
    deletePart(id: $id)
  }
`;
